export function shouldShow(state, confirmation_status) {
  return (
    typeof state !== 'undefined' &&
    state === 'SCHEDULED' &&
    confirmation_status === 'UNCONFIRMED'
  )
}
